export function getPropertyTypeFilters(t: any) {
  return [
    {id: 'HOTEL', name: t('propertyTypes.hotels'), icon: '/resources/images/hotel.svg'},
    {id: 'HOLIDAY_HOME', name: t('propertyTypes.holidayHomes'), icon: '/resources/images/holiday-home.svg'},
    {id: 'VILLA', name: t('propertyTypes.villas'), icon: '/resources/images/villa.svg'},
    {id: 'CAMP', name: t('propertyTypes.camps'), icon: '/resources/images/campsite.svg'},
  ]
};